module.exports = __webpack_public_path__ + "img/Admin.9dff8800.svg";